import { render } from "./Downloads.vue?vue&type=template&id=73d450f0&scoped=true"
const script = {}

import "./Downloads.vue?vue&type=style&index=0&id=73d450f0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-73d450f0"

export default script